import "swiper/swiper-bundle.css";

import { Autoplay, Pagination } from "swiper/modules";

import Swiper from "swiper";

Array.from(document.querySelectorAll(".image-rich-text .swiper")).map(
	(hero) => {
		const swiper = new Swiper(hero, {
			modules: [Autoplay, Pagination],
			autoplay: {
				delay: 7500,
			},
			loop: true,
			pagination: {
				el: ".swiper-pagination",
				type: "bullets",
				clickable: true,
			},
		});
	}
);
